import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Buttons, EdgeButton } from "../../../Constant";
import EdgeDefaultButtons from "./DefaultButtons";
import EdgeLargeButtons from "./LargeButtons";
import EdgeSmallButtons from "./SmallButtons";
import EdgeActiveButtons from "./ActiveButtons";
import EdgeDisabledButtons from "./DisabledButtons";
import EdgeCustomStateButtons from "./CustomStateButtons";
import EdgeOutlineButtons from "./OutlineButtons";
import EdgeBoldBorderOutlineButtons from "./BoldBorderOutlineButtons";
import EdgeOutlineLargeButtons from "./OutlineLargeButtons";
import EdgeOutlineSmallButtons from "./OutlineSmallButtons";
import EdgeExtraSmallButtons from "./ExtraSmallButtons";
import EdgeOutlineExtraSmallButtons from "./OutlineExtraSmallButtons";
import EdgeDisabledOutlineButtons from "./DisabledOutlineButtons";
import EdgeGradienButtons from "./GradienButtons";

const EdgeStyleContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={EdgeButton} parent={Buttons} title={EdgeButton} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <EdgeDefaultButtons />
            <EdgeLargeButtons />
            <EdgeSmallButtons />
            <EdgeExtraSmallButtons />
            <EdgeActiveButtons />
            <EdgeDisabledButtons />
            <EdgeCustomStateButtons />
            <EdgeOutlineButtons />
            <EdgeBoldBorderOutlineButtons />
            <EdgeOutlineLargeButtons />
            <EdgeOutlineSmallButtons />
            <EdgeOutlineExtraSmallButtons />
            <EdgeDisabledOutlineButtons />
            <EdgeGradienButtons />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default EdgeStyleContainer;
